import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import localization from 'moment/locale/de'

import { PLANTS } from '../../constants/routes'
import { isDefaultSensorImage } from '../utilities/helpers'
import {
    TabsContentHeader,
    TabsContentHeadline,
    TabsContainer
} from '../StyledComponents/Plants/PlantTabs'
import {
    DeviceDetailsImage,
    DeviceDetailsName,
    DeviceDetailsLastUpdate,
    DeviceDetailsOverview,
    DeviceDetailsOverviewIcon,
    DeviceDetailsOverviewText,
    AddPlantIcon
} from '../StyledComponents/Devices/DeviceDetails'
import PlantListItem from '../Plant/PlantListItem'
import MoistureChart from './MoistureChart'

import { FillerDiv } from '../StyledComponents/Fillers'

const batteryGreen = require('../../assets/images/DevicesList/batteryGreen.svg')
const batteryOrange = require('../../assets/images/DevicesList/batteryOrange.svg')
const batteryRed = require('../../assets/images/DevicesList/batteryRed.svg')
const sensorImage = require('../../assets/images/DevicesList/sensor.png')
const moistureIcon = require('../../assets/images/CareIcons/005-drop.png')

class SensorDetails extends Component {
    constructor(props) {
        super(props)

        this.onAddPlantClicked = this.onAddPlantClicked.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    onAddPlantClicked() {
        this.props.history.push(PLANTS)
    }

    render() {
        const { device } = this.props
        const { soc } = device

        let batteryIcon = null
        let batteryColor = 'black'
        if (soc < 20) {
            batteryIcon = batteryRed
            batteryColor = 'danger'
        } else if (soc < 50) {
            batteryIcon = batteryOrange
            batteryColor = 'warning'
        } else {
            batteryIcon = batteryGreen
            batteryColor = 'success'
        }

        const image = isEmpty(device.image) ? sensorImage : device.image
        const plants = device.plants.map(plant => <PlantListItem style={{ margin: '0' }} plant={plant} key={plant.id} />)

        return (
            <FillerDiv>
                <DeviceDetailsImage
                    contain={isDefaultSensorImage(device.image)}
                    src={image}
                    alt={device.name}
                />
                <DeviceDetailsName>{device.name}</DeviceDetailsName>
                <DeviceDetailsLastUpdate>{`${moment(device.last_measure_date).locale('de', localization).calendar()}`}</DeviceDetailsLastUpdate>
                <FillerDiv className="container">
                    <DeviceDetailsOverview className="row">
                        <FillerDiv className="col-6">
                            <DeviceDetailsOverviewIcon src={moistureIcon} alt="Bodenfeuchte" />
                            <DeviceDetailsOverviewText>
                                {device.current_moisture}%
                            </DeviceDetailsOverviewText>
                        </FillerDiv>
                        <FillerDiv className="col-6">
                            <DeviceDetailsOverviewIcon src={batteryIcon} alt="Akkustand" />
                            <DeviceDetailsOverviewText color={batteryColor}>
                                {device.soc}%
                            </DeviceDetailsOverviewText>
                        </FillerDiv>
                    </DeviceDetailsOverview>
                </FillerDiv>
                <FillerDiv>
                    <TabsContainer>
                        <TabsContentHeader>
                            <TabsContentHeadline margin="0 0 15px 0">Pflanzen</TabsContentHeadline>
                            <AddPlantIcon name="plus" size="lg" onClick={this.onAddPlantClicked} />
                            {plants}
                        </TabsContentHeader>
                        <TabsContentHeader margin="40px 0">
                            <TabsContentHeadline>Messwerte</TabsContentHeadline>
                            <MoistureChart data={device.data} />
                        </TabsContentHeader>
                    </TabsContainer>
                </FillerDiv>
            </FillerDiv>
        )
    }
}

export default withRouter(SensorDetails)



// WEBPACK FOOTER //
// ./src/components/Devices/SensorDetails.js